import React from "react";
import { Link, useLocation } from "react-router-dom";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import Msgalert from "../views/Msgalert";
import { encStorage } from "../hooks/encStorage";
import { GET_CLIENT_BANKS, DELETE_CLIENT_BANK } from "../services/Apis";
import axios from "axios";
import { useEffect, useState } from "react";

const Clientbanks = () => {
  const [SidebarState, setSidebarState] = useState(false);
  const location = useLocation();
  const { state } = location;
  useEffect(() => {
    window.history.replaceState({}, document.title);
  }, []);
  const [message, setMessage] = useState(state?.message);
  const [messagestatus, setMessagestatus] = useState(state?.status);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setMessage(null);
        setMessagestatus(null);
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const user = encStorage.getItem("user");
  const [ClientBanks, setClientBanks] = useState([]);
  const [loading, setLoading] = useState(true);

  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this bank?"
    );
    if (!confirmDelete) return;

    const token = encStorage.getItem("token");
    const formData = new FormData();
    formData.append("id", id);
    try {
      await axios.post(`${DELETE_CLIENT_BANK}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setClientBanks((prevBanks) => prevBanks.filter((bank) => bank.id !== id));
    } catch (error) {
      console.error("Error deleting Client Bank:", error);
    }
  };
  const fetchClientBanks = async () => {
    const token = encStorage.getItem("token");
    try {
      const response = await axios.get(GET_CLIENT_BANKS, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setClientBanks(response.data.banks);
    } catch (error) {
      console.error("Error fetching Client Banks:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchClientBanks();
  }, []);

  const [showMessage, setShowMessage] = useState(true);

  useEffect(() => {
    if (message) {
      const timer = setTimeout(() => {
        setShowMessage(false);
        setMessage("");
      }, 10000);
      return () => clearTimeout(timer);
    }
  }, [message]);

  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content" className="layout-content">
          <main>
            <div className="container-fluid px-4">
              {showMessage && message && (
                <Msgalert message={message} status={messagestatus} />
              )}
              <div className="d-flex">
                <h3 className="mt-4 w-75">Client Banks</h3>
                <div className="mt-auto me-0 w-25 d-flex justify-content-end">
                  <Link
                    to="/my-banks/create"
                    className="btn btn-primary"
                    title="New"
                  >
                    <span className="d-md-inline">Add Bank</span>
                  </Link>
                </div>
              </div>
              <ol className="breadcrumb mb-4">
                <li className="breadcrumb-item">
                  <Link to="/clientbanks">Listing</Link>
                </li>
              </ol>
              <div className="d-flex flex-shrink-0"></div>
              <div className="card mb-4">
                <div className="card-title ps-3 pt-3 text-bold">
                  Recent Client Banks
                </div>
                <div className="card-body">
                  <div className="table-responsive">
                    <table
                      className="table table-bordered table-striped w-100 align-middle"
                      id="record-table"
                    >
                      <thead>
                        <tr>
                          <th>Account Name</th>
                          <th>Bank</th>
                          <th>Account No</th>
                          <th>Ifsc</th>
                          <th style={{ width: "5%" }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading ? (
                          <tr>
                            <td colSpan="6">Loading...</td>
                          </tr>
                        ) : ClientBanks.length === 0 ? (
                          <tr>
                            <td colSpan="6" className="text-center">
                              No records found
                            </td>
                          </tr>
                        ) : (
                          ClientBanks.map((clientBank) => (
                            <tr key={clientBank.id}>
                              <td>{clientBank.account_holder_name}</td>
                              <td>{clientBank.bank}</td>
                              <td>{clientBank.account_no}</td>
                              <td>{clientBank.ifsc}</td>
                              <td>
                                <Link
                                  onClick={() => handleDelete(clientBank.id)}
                                  className="btn btn-sm btn-danger"
                                >
                                  <i className="fas fa-trash"></i>
                                </Link>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default Clientbanks;
